/*
 * @Author: changcheng 364000100@#qq.com
 * @Date: 2023-12-26 09:23:38
 * @LastEditors: changcheng 364000100@#qq.com
 * @LastEditTime: 2025-08-04 11:15:03
 * @FilePath: /mvw_project/mvw-online-pc/src/reducers/projectInfo.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import logo from "../img/logo_header.png";
const InitProjectType = {
  projectName: "",
  showLogoFlag: 1,
  showIndexUrlFlag: 1,
  showPersonCenterFlag: 1,
  projectAllPathLogo: logo,
};
export const projectInfo = (
  state = InitProjectType,
  action: {
    type: string;
    payLoad: {
      projectName?: string;
      showLogoFlag?: number;
      showIndexUrlFlag?: number;
      showPersonCenterFlag?: number;
      projectAllPathLogo: any;
    };
  }
) => {
  switch (action.type) {
    case "CHANGE_PROJECTINFO":
      return {
        ...InitProjectType,
        ...action.payLoad,
      };
    default:
      return state;
  }
};
